<template>
  <a-modal title="新增" :width="600" :visible="visible" :confirmLoading="confirmLoading" @cancel="handleCancel">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="百应id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['dy_user_id', { rules: [{ required: true, message: '必填项' }] }]" placeholder="请填写" />
        </a-form-item>
        <a-form-item label="cookie" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['cookie', { rules: [{ required: true, message: '必填项' }] }]" placeholder="请填写" />
        </a-form-item>
        <a-form-item label="备注信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['remark']" placeholder="请填写" />
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button :loading="confirmLoading" type="primary" @click="handleSubmit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import CompanyApi from '@/api/company'
export default {
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      currentRobotId: '',
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this)
    }
  },
  methods: {
    show (currentRobotId) {
      this.currentRobotId = currentRobotId
      this.visible = true
    },
    handleCancel () {
      this.visible = false
    },
    handleSubmit (e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          // if ((values.cookie.indexOf(" ") != -1)) {
          //   this.$message.error('填写信息有误，请检查cookie是否包含空格')
          //   return false
          // }
          this.confirmLoading = true
          CompanyApi.addDouyin({
            cookie: values.cookie,
            remark: values.remark,
            dy_user_id:values.dy_user_id,
            is_sync:2        
          }).then((res) => {
              if (res.code === 1) {
                this.form.resetFields()
                this.$message.success("新增成功")
                this.visible = false
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            }).finally(() => {
              this.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>
